const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/posts.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/posts")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});